import React from 'react';
import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../assets/icons/close.png'
import AutoCompleteMultiSelect from '../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
function SectionImport(props) {
    const handleClose = () => {
        props.onHandleAddItem(false)
    }
    const [restaurantVal, setRestaurantVal] = React.useState();
    const restaurantValue = (props) => {
        console.log(props)
        setRestaurantVal(props);
    }
    const restDatas = [
        { id: 1, title: 'PKB london' },
        { id: 2, title: 'PKB Manchester' }
    ]
    const menuDatas = [
        { id: 1, title: 'Burger' },
        { id: 2, title: 'Chicken' },
        { id: 3, title: 'Pizza' },
    ]
    const [sectionVal, setsectionVal] = React.useState();
    const sectionValue = (props) => {
        console.log(props)
        setsectionVal(props)
    }
    const saveData = () => {
        let value = {
            restaurant: restaurantVal,
            section: sectionVal,
        }
        props.onHandleAddItem(value);
    }
    return (
        <React.Fragment>

            <Dialog

                className=''
                open={props.open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'lg'}
            >

                <Grid container>
                    <Grid item xs={6}>
                        <DialogTitle>
                            <div className='d-flex' style={{ gap: "8px" }}>
                                {/* <div>
                                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                </div> */}

                                <span style={{ color: "#2a7fd4" }}>Import Section</span>
                            </div>
                        </DialogTitle>
                        {/* {dialogType === 'sub' && <DialogTitle>Sub Section</DialogTitle>} */}
                    </Grid>
                    <Grid item xs={6}>
                        <DialogActions>
                            <Button onClick={handleClose}>
                                <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                            </Button>
                        </DialogActions>
                    </Grid>
                </Grid>
                <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                    <div>

                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Restaurant Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Restaurant Name"}
                                    placeholder={'Restaurant Name'}
                                    value={restaurantValue}
                                    datas={restDatas}
                                    id={1}
                                />

                            </Grid>
                        </Grid>

                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Section Name
                                </Typography>
                            </Grid>
                            <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                <AutoCompleteMultiSelect
                                    label={"Section Name"}
                                    placeholder={'Section Name'}
                                    value={sectionValue}
                                    datas={menuDatas}
                                    id={1}
                                />

                            </Grid>
                        </Grid>
                        {
                            props.type === "Add Sub Section" ? (
                                <Grid container sx={{ padding: '0.5rem' }}>
                                    <Grid item xs={2}>
                                        <Typography style={{ paddingTop: '1rem' }}>
                                            Sub Section Name
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                                        <AutoCompleteMultiSelect
                                            label={"Sub Section Name"}
                                            placeholder={'Sub Section Name'}
                                            value={sectionValue}
                                            datas={menuDatas}
                                            id={1}
                                        />

                                    </Grid>
                                </Grid>
                            ) : ""
                        }
                        {/* <ImportItemView open={openImport} dialogType={dialogType} onHandleAddItem={handleImportItem} /> */}
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <div className='d-flex justify-content-end'
                                >
                                    <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                                </div>

                            </Grid>
                        </Grid>

                    </div>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}

export default SectionImport;